import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { utcToDate } from "../../utils/dateConvert";
import { rounding } from "../../utils/math";
import Location from '../commoncomponents/location'

class DuressTable extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  render() {
    const sortedDuressList = [...this.props.duressList].sort(function (a, b) {
      var d = new Date(a.created);
      var c = new Date(b.created);
      return c - d;
    });

    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Depot</th>
            <th>Last Reported</th>
            <th>Occured</th>
            <th>Location</th>
            <th>SIM</th>
            <th>IMEI</th>
            <th>Engine</th>
            <th>Speed</th>
          </tr>
        </thead>
        <tbody>
          {sortedDuressList.map((item, index) => {
            let gPRMC = item.gPRMC || {};

            return (
              <tr>
                <td>{item.assetName}</td>
                <td>{item.depotName}</td>
                <td>{utcToDate(item.lastReported)}</td>
                <td>{utcToDate(item.created)}</td>
                <td>
                  <Location
                    address={item.location}
                    lat={gPRMC.latitude}
                    lng={gPRMC.longitude}
                  />
                </td>
                <td>{item.sim}</td>
                <td>{item.imei}</td>
                <td>{item.engine ? "On" : "Off"}</td>
                <td>{rounding(item.speed)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default DuressTable;
